<script lang="ts" setup>
import { computed } from "vue";
import { usePrescriptionStore } from "../../../../store/transitient/prescription";
import MBanner from "../../../medicus/MBanner";
import MSection from "../../../medicus/MSection";
import MSearchSelectDrug from "../../../medicus/inputs/MSearchSelect/MSearchSelectDrug.vue";
import { determineOptimiseRxBannerPosition } from "../OptimiseRx/optimise-rx";
import { OptimiseRxBanners } from "../OptimiseRx";

const store = usePrescriptionStore();

function onDrugSelectorInputValue(val: string) {
  if (val) return;
  store.drugOrDevice = null;
}

function switchToGenericItem() {
  // @ts-expect-error MSelect will fix the correct type
  store.drugOrDevice = store.metaInformation?.alternativeItems?.[0];
}

const isReauthorising = computed(() => {
  return ["re-authorise", "prescribe-again"].indexOf(store.prescriptionFormType) !== -1;
});

const searchUrl = computed(() => {
  let baseUrl = `/clinical/data/gb/nhs/dmd/search/prescription/product?patientId=${store.patientId}`;

  if (store.form.originalPrescriptionId && true === isReauthorising.value) {
    baseUrl += `&originalPrescriptionId=${store.form.originalPrescriptionId}`;
  }

  return baseUrl;
});

const drugAndDeviceActions = computed(() =>
  store.loadingChecks
    ? []
    : [
        store.metaInformation?.alternativeItems?.length &&
          store.metaInformation?.alternativeItems[0]?.value?.itemCode !==
            store.prescription.productCode && {
            label: "Change to generic",
            click: switchToGenericItem,
            "data-testid": "change-generic-item-btn",
          },
      ].filter(Boolean),
);

const computedOptimiseRxProductResults = computed(() => {
  let results = [];

  store.optimiseRxProspectiveDrugResultSet?.forEach((result) => {
    result.metaDataItems.forEach((metaDataItem) => {
      let bannerPosition = determineOptimiseRxBannerPosition(result, metaDataItem);

      if ("product" === bannerPosition) {
        if (results.filter((res) => res.ruleId === result.ruleId).length === 0) {
          results.push(result);
        }
      }
    });
  });

  return results;
});
</script>
<template>
  <m-section title="Medication">
    <m-search-select-drug
      v-model="store.drugOrDevice"
      label="Product"
      placeholder="Search products"
      required
      clearable
      :search-url="searchUrl"
      actions-left
      :actions="drugAndDeviceActions"
      data-testid="drug-device-search"
      data-focus-first
      :min-search-value-length="3"
      debounce="300"
      @input-value="onDrugSelectorInputValue"
    />
    <m-banner
      v-if="store.state.productWarning && !store.drugOrDevice"
      type="warning"
      data-testid="product-warning-banner"
    >
      {{ store.state.productWarning }}
    </m-banner>
    <m-banner
      v-if="store.metaInformation?.brandNameProductPrescribingAdvised"
      type="warning"
      data-testid="brand-name-product-prescribing-banner"
    >
      <p>Brand name product prescribing is advised for this product.</p>
    </m-banner>

    <OptimiseRxBanners
      v-if="store.drugOrDevice && computedOptimiseRxProductResults.length > 0"
      :results="computedOptimiseRxProductResults"
      :expanded="true"
    />
  </m-section>
</template>
